import React from 'react';
import Ad from 'tradera-components/ads/ad';

const DESKTOP = 'desktop';
const TABLET = 'tablet';
const MOBILE = 'mobile';

const DESKTOP_AUTOSCALE_OFFSET = 980;
const TABLET_AUTOSCALE_OFFSET = 434;

const getAdPosision = (index, device) => {
    switch (index) {
        case 1:
            return `mid1-${device}`;
        case 2:
            return `mid2-${device}`;
        case 3:
            return `mid3-${device}`;
        default:
            return `top-${device}`;
    }
};

/**
 * Helper method for creating ad
 *
 * @param {string} deviceName
 * @param {string} adFormats
 * @param {number} index
 * @param {object} props
 */
const buildProps = (
    deviceName,
    adFormats,
    index,
    autoscaleOffsetWidth,
    props
) => {
    return {
        adContainerClass: '',
        autoscaleOffsetWidth,
        className: 'd-empty-none px-0 col-12 mx-auto mb-4',
        adFormats,
        deviceName,
        position: getAdPosision(index, deviceName),
        ...props
    };
};

const DesktopAd = ({ index, ...props }) => (
    <Ad
        {...buildProps(
            DESKTOP,
            'panorama',
            index,
            DESKTOP_AUTOSCALE_OFFSET,
            props
        )}>
        <div className="ad-placeholder-desktop-980-240" />
    </Ad>
);

const TabletAd = ({ index, ...props }) => (
    <Ad
        {...buildProps(
            TABLET,
            'panorama',
            index,
            TABLET_AUTOSCALE_OFFSET,
            props
        )}>
        <div className="ad-placeholder-tablet" />
    </Ad>
);

const MobileAd = ({ index, ...props }) => (
    <Ad
        {...buildProps(
            MOBILE,
            'mobile_rectangle,medium_rectangle,mobile_wideboard',
            index,
            undefined,
            props
        )}>
        <div className="ad-placeholder-mobile-320-320" />
    </Ad>
);

export { DesktopAd, TabletAd, MobileAd };
